import { SERVICE_URL } from "./app.const";
import { fetchPatch, fetchPut } from "./response";

export function updateProfileImage(image, token) {
  return fetchPatch(`${SERVICE_URL}/profile/me/image`, token, { image });
}

export function updateProfileLanguage(language, token) {
  return fetchPatch(`${SERVICE_URL}/profile/me/language`, token, { language });
}

export function changeProfilePassword(currentPassword, newPassword, token) {
  return fetchPut(`${SERVICE_URL}/profile/me/password`, token, {
    body: { currentPassword, newPassword },
  });
}
